import React from 'react';
import { GiSoundWaves } from 'react-icons/gi';
import { NavSubmenuDivider, NavSubmenuLabel } from './navMenuLayout';
import AreaBudgetNavPanel from './AreaBudgetNavPanel';
import { canAccessAreaBudgetMenu } from './areaBudgetNavUtils';

const RECORDING_CHILD_ROUTES = [
  '/recording/map',
  '/recording/planning',
  '/recording/production-reports',
  '/budgets/recording',
  '/budgets/recording/new',
  '/budgets/management?area=recording',
  '/dailies/recording/new',
  '/dailies/management?area=recording',
  '/summary/recording',
];

export default function RecordingNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  closeMobileSidebar,
}) {
  if (!hasMenuAccessOrChild('/recording', RECORDING_CHILD_ROUTES)) {
    return null;
  }

  const canAccessBudget = canAccessAreaBudgetMenu('recording', hasMenuAccess);

  return (
    <MenuItem customIcon={<GiSoundWaves style={{ width: '24px', height: '24px' }} />} title="Recording" id="recording">
      {(canAccessBudget
        || hasMenuAccess('/recording/planning')
        || hasMenuAccess('/dailies/recording/new')
        || hasMenuAccess('/dailies/management?area=recording')) && (
        <>
          <NavSubmenuLabel>Planning</NavSubmenuLabel>
          {canAccessBudget && (
            <AreaBudgetNavPanel
              area="recording"
              SubMenuItem={SubMenuItem}
              hasMenuAccess={hasMenuAccess}
              closeMobileSidebar={closeMobileSidebar}
            />
          )}
          {hasMenuAccess('/recording/planning') && <SubMenuItem to="/recording/planning">Field Planning</SubMenuItem>}
          {hasMenuAccess('/dailies/recording/new') && <SubMenuItem to="/dailies/recording/new">New Daily</SubMenuItem>}
          {hasMenuAccess('/dailies/management?area=recording') && (
            <SubMenuItem to="/dailies/management?area=recording">Dailies Management</SubMenuItem>
          )}
        </>
      )}
      {(hasMenuAccess('/recording/map') || hasMenuAccess('/recording/production-reports')) && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Operations</NavSubmenuLabel>
          {hasMenuAccess('/recording/map') && <SubMenuItem to="/recording/map">📍 Map</SubMenuItem>}
          {hasMenuAccess('/recording/production-reports') && (
            <SubMenuItem to="/recording/production-reports">📈 Production Reports</SubMenuItem>
          )}
        </>
      )}
      {hasMenuAccess('/summary/recording') && (
        <>
          <NavSubmenuDivider />
          <NavSubmenuLabel>Reports</NavSubmenuLabel>
          <SubMenuItem to="/summary/recording">Summary</SubMenuItem>
        </>
      )}
    </MenuItem>
  );
}
